import React, { HTMLAttributes, ReactNode } from 'react';
import Typo from '../../atom/Typo';
import LucideIcon from '../../atom/Icons/LucideIcon';

interface MainContentTitleProps extends HTMLAttributes<HTMLDivElement> {
  pageTitle: string | ReactNode;
  breadcrumbList?: string[];
}

function MainContentTitle({
  pageTitle,
  breadcrumbList,
  ...props
}: MainContentTitleProps) {
  const renderPageTitle = () => {
    if (typeof pageTitle === 'string') {
      return <Typo typoType="h26sb">{pageTitle}</Typo>;
    }

    return pageTitle;
  };

  return (
    <section className="flex flex-col gap-y-2 py-5" {...props}>
      <div className="flex items-center gap-x-1">
        {breadcrumbList?.map((item, idx) => {
          if (breadcrumbList.length - 1 === idx) {
            return (
              <Typo key={idx.toString()} typoColor="gray7">
                {item}
              </Typo>
            );
          }

          return (
            <div className="flex items-center gap-x-1" key={idx.toString()}>
              <Typo typoColor="gray4">{item}</Typo>
              <LucideIcon name="ChevronRight" color="gray4" />
            </div>
          );
        })}
      </div>

      {renderPageTitle()}
    </section>
  );
}

export default MainContentTitle;
